<template>
  <div>
    <div class="order-form">
      <div v-if="step == 'form'">
        <div class="row">
          <div class="col-sm-10">
            <div class="form-group" v-bind:class="{ 'has-error': errors.name }">
              <label>Ваше имя</label>
              <input type="text" class="form-control" v-model="contact.name" name="field1">
              <p class="help-block" v-if="errors.name">
                {{ errors.name.join(', ') }}
              </p>
            </div>
          </div>
          <div class="col-sm-10">
            <div class="form-group" v-bind:class="{ 'has-error': errors.phone }">
              <label>Телефон</label>
              <input type="text" class="form-control" v-model="contact.phone" v-mask="'+7(###)###-##-###'" placeholder="+7(xxx)xxx-xx-xx" required="required">
              <p class="help-block" v-if="errors.phone">
                {{ errors.phone.join(', ') }}
              </p>
            </div>
          </div>
          <div class="col-sm-10">
            <div class="form-group" v-bind:class="{ 'has-error': errors.email }">
              <label>Email</label>
              <input type="text" class="form-control" v-model="contact.email">
              <p class="help-block" v-if="errors.email">
                {{ errors.email.join(', ') }}
              </p>
            </div>
          </div>
          <div class="col-sm-10">
            <div class="form-group" v-bind:class="{ 'has-error': errors.city }">
              <label>Город</label>
              <input type="text" class="form-control" v-model="contact.city" name="field2" required="required">
              <p class="help-block" v-if="errors.city">
                {{ errors.city.join(', ') }}
              </p>
            </div>
          </div>
          <div class="form-group" v-bind:class="{ 'has-error': errors.address }">
            <label>Адрес доставки</label>
            <input type="text" class="form-control" v-model="contact.address" name="field2" required="required">
            <p class="help-block" v-if="errors.address">
              {{ errors.address.join(', ') }}
            </p>
          </div>
        </div>
        <div class="form-group" v-bind:class="{ 'has-error': errors.comment }">
          <label>Комментарий</label>
          <textarea class="form-control" v-model="contact.comment"></textarea>
        </div>

        <div class="form-group">
          <div class="form-group-submit-btn">
            <button class="btn btn-primary" v-on:click="sendForm" type="button">Отправить</button>
          </div>
        </div>
      </div>

      <div v-if="step == 'complete'">
        <p class="text-success">
          Ваш заказ успешно отправлен! Мы подготовим точный расчет стоимости и свяжемся с вами.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'

import CartMixin from '../vue_mixins/CartMixin.vue'

Vue.use(VueMask)

export default {
  name: 'CheckPage',
  mixins: [CartMixin],
  data() {
    return {
      step: 'form',
      contact: {},
      errors: {}
    }
  },
  mounted() {
    axios.get("/cart/api/order/").then(response => {this.contact = response.data});
  },
  methods: {
    sendForm: function () {
      axios.put("/cart/api/order/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.step = 'complete';
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    }
  }
}
</script>

<style lang="scss">
</style>
